export default {
  CACHE_EXPIRY: 30,
  VARIANTS: {
    default: 'default',
    mini: 'mini'
  },
  ASSETS: {
    default: '/header-assets/header.json',
    mini: '/header-assets/miniHeader.json'
  },
  ENDPOINTS: {
    development: 'https://header-service.service.eu-west-1.dev.deveng.systems',
    staging: 'https://header-service.public.eu-west-1.staging.deveng.systems',
    production: 'https://www.argos.co.uk'
  },
  BOSUN_ENDPOINTS: {
    development: 'https://nav-pdp-argos-header-service.int.dev.jspaas.uk',
    staging: 'https://nav-pdp-argos-header-service.int.stg.jspaas.uk',
    production: 'https://www.argos.co.uk'
  },
  REQUEST_HEADERS: {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache'
    }
  },
  ERR_SCRIPT_LOAD_FAIL: 'HAAS unreachable, falling back to non-HAAS. Exception when requesting:',
  ERR_MISSING_BUNDLE:
    'HAAS <script> tag JSX failed to render. Ensure the Express header middleware is fetching the service JSON correctly',
  ERR_MISSING_STYLES:
    'HAAS <style> tag JSX failed to render. Ensure the Express header middleware is fetching the service JSON correctly'
}
